import React from 'react';
import styled, { StylesProps, cx } from '../../../lib/styles';
import { Article } from '../../../models/article';

import heavyStyles from './HeavyStory_styles';
import { FeaturedTileBlock } from '../../../views/Collection/CollectionBlock/Blocks/HeroTilesBlock/HeroTilesBlock';

interface HeavyStoryProps {
  slot?: string;
  attribute?: boolean;
  onClick?: () => any;
  article: Article;
  lazy?: boolean;
  image?: boolean;
}

const HeavyStory = ({
  slot,
  article,
  styles,
}: HeavyStoryProps & StylesProps<typeof heavyStyles>) => (
  <div id={slot} data-parsely-slot={slot} className={styles.container}>
    <FeaturedTileBlock
      featuredArticle={article}
      styles={{
        flex: `0 0 100% !important`,
        width: `100% !important`,
        minHeight: `500px !important`,
      }}
    />
  </div>
);

export default styled(heavyStyles)(HeavyStory);
